import { getBaseUrl } from "./config";
import { ESuggestionTypes } from "./utils/ESuggestionTypes";
import md5 from 'md5';
// import { captcha } from "../captcha";
import { http } from "../../../http";
import { debouncePromised } from "../debouncePromised";
import { handleSessionExpired } from "../../../handleSessionExpired";

export { EAddrConstraintsTypes } from './utils/EAddrConstraintsTypes';
export { EAddressBounds } from './utils/EAddressBounds';
export { EFioParts } from './utils/EFioParts';
export { EGender } from './utils/EGender';

class DadataApi {

    constructor() {
        this.suggestUrl = `${getBaseUrl()}/suggest/`;
        this.ipLocateUrl = `${getBaseUrl()}/iplocate/address`;

        this._cache = [];

        /**
         * Ждет когда будет готово апи
         * @returns 
         */
        this._init = debouncePromised(async () => {
            // await captcha.check();
        })

        /**
         * Получить данные о локации по ip
         */
        this.getLocationByIp = debouncePromised(async () => {
            await this._init();

            const { data } = await http.get(this.ipLocateUrl, { includeSessionId: true }).catch(handleSessionExpired);
            return data?.location?.data;
        })
    }

    /**
     * Запросить подсказки дадата
     * @param {string} type
     * @param {string} query
     * @param {number} count
     * @param {object} options
     * @param {boolean} restrict_value
     * @returns {array} массив с объектами дадата
     */
    async suggest(type, query = '', count = 5, options = {}, restrict_value, locations) {
        if (!Object.values(ESuggestionTypes).includes(type))
            throw Error('не указан тип подсказки');

        const key = md5(`${type}_${query}_${count}_${JSON.stringify(options)}_${restrict_value}_${JSON.stringify(locations)}`);

        const keyIndex = this._cache.findIndex((item) => item.key === key);
        if (keyIndex > -1)
            return this._cache[keyIndex].value;

        await this._init();

        const { data } = await http.post(`${this.suggestUrl}${type}`, {
            query,
            count,
            ...options,
            restrict_value,
        }, { includeSessionId: true }).catch(handleSessionExpired);

        if (data.suggestions)
            if (this._cache.length >= this._cacheLimit) this._cache.shift()
            this._cache.push({ key, value: data.suggestions });

        return data.suggestions ?? [];
    }
}

/**
 * Datata singleton
 */
export const dadataApi = new DadataApi();

export {
    ESuggestionTypes,
}
